<template>
  <fieldset class="coderate_fieldset">
    <legend>{{ language.rateLegend }}</legend>
    <input type="hidden" name="coderate" id="ratecode" :value="rate.code" />
    <div class="form-row form-row--wide editable">
      <div class="form-field" v-click-outside="hideDropdown">
        <label for="coderate_display">{{ language.rateLegend }}</label>
        <input
          name="rate_display"
          id="coderate_display"
          ref="coderate"
          :value="rate.name"
          autocomplete="off"
          readonly="readonly"
          @click="openDropdown"
          @keydown.enter.prevent="toggleDropdown"
          @keydown.space="openDropdown"
          @keyup.escape="hideDropdown"
          @focus="onFocus"
        />
        <a
          href="#"
          role="button"
          class="edit-toggle"
          :aria-label="language.editRateCode"
          @keydown.enter.prevent="enterEditMode"
          @click.prevent="enterEditMode"
          tabindex="-1"
          >{{ language.editRateCode }}</a
        >
        <div
          :class="dropDownOpen ? 'input-dropdown open' : 'input-dropdown'"
          v-if="dropDownOpen"
        >
          <div class="input-dropdown__segment" v-if="visibleRates.length > 0">
            <header>
              {{ language.ratesOfferings }}
            </header>
            <ul>
              <li v-for="currentRate in visibleRates" :key="currentRate.code">
                <a
                  href="#"
                  v-html="currentRate.name"
                  v-bind:class="{
                    active: !usePromo && currentRate.code == rate.code,
                  }"
                  @click.prevent="selectRate(currentRate)"
                  v-if="!currentRate.inactive"
                ></a>
                <a
                  v-html="currentRate.name"
                  class="inactive"
                  v-if="currentRate.inactive"
                ></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </fieldset>
</template>

<script>
import ClickOutside from "vue-click-outside";

export default {
  name: "RateCode",

  data: function () {
    return {
      dropDownOpen: false,
      timeout: null,
    };
  },

  mounted: function () {
    this.$store.commit("setRate", this.getDefaultRate());
  },

  computed: {
    editMode: function () {
      return true;
    },
    language: function () {
      return this.$store.state.language;
    },

    isCancellable: function () {
      return this.rate.code != this.defaultRate || this.usePromo;
    },

    usePromo: function () {
      return !!this.$store.state.promo || false;
    },

    defaultRate: function () {
      return this.$store.state.defaultRate;
    },

    rates: function () {
      return this.$store.state.rates;
    },

    rate: function () {
      if (!this.$store.state.rate) {
        return this.getDefaultRate();
      }
      return this.$store.state.rate;
    },

    ratename: function () {
      return this.rate.name;
    },

    ratecode: function () {
      return this.rate.code;
    },

    promo: {
      get() {
        return this.$store.state.promo;
      },
      set(value) {
        const that = this;
        if (this.timeout) clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          that.$store.dispatch("addPromo", { promo: value });
        }, 333);
      },
    },

    visibleRates: function () {
      return this.rates.filter((rate) => !rate.invisible);
    },
  },

  methods: {
    enterEditMode() {
      this.$refs.coderate.focus();
      this.openDropdown();
    },

    getDefaultRate() {
      const defaultRate = this.$store.state.defaultRate;
      let defaultRates = this.$store.state.rates.filter(
        (rate) => rate.code == defaultRate
      );
      return defaultRates.shift();
    },

    toggleDropdown() {
      if (this.dropDownOpen) return this.hideDropdown();
      return this.openDropdown();
    },

    onFocus() {
      this.$emit("focus");
    },

    openDropdown() {
      this.dropDownOpen = true;
      this.$emit("opened");
    },

    hideDropdown() {
      this.dropDownOpen = false;
    },

    selectRate(rate) {
      this.dropDownOpen = false;
      this.usePromo = false;
      this.promo = "";
      this.$store.dispatch("chooseRate", { rate: rate });
    },

    selectPromoText() {
      this.$refs.promo.select();
    },

    clearSelection() {
      this.$store.dispatch("chooseRate");
      this.$store.dispatch("addPromo");
      this.$nextTick(function () {
        this.isCancellable = false;
        this.usePromo = false;
      });
    },
  },

  // do not forget this section
  directives: {
    ClickOutside,
  },
};
</script>